import React from 'react';
import PropTypes from 'prop-types';
/* Reatcstrap */
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import FdeList from '../components/List';

const FdeModal = ({
  fde,
  fetchFde,
  isOpen,
  loading,
  onClose,
  orderSelected,
  title,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
    size="lg"
  >
    <ModalHeader toggle={onClose}>{title}</ModalHeader>
    <ModalBody>
      <FdeList
        fde={fde}
        fetchFde={fetchFde}
        isLoading={loading}
        isOpen={isOpen}
        orderSelected={orderSelected}
      />
    </ModalBody>
  </Modal>
);

FdeModal.propTypes = {
  fde: PropTypes.array,
  fetchFde: PropTypes.func,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  orderSelected: PropTypes.object,
  title: PropTypes.string,
};

FdeModal.defaultProps = {
  fde: [],
  fetchFde: () => {},
  isOpen: false,
  loading: false,
  onClose: () => {},
  orderSelected: {},
  title: 'Flujos de Efectivo',
};

export default FdeModal;
